// extracted by mini-css-extract-plugin
export default {"text":"SectionTitle_text__9sBih"};